// import { createStore, combineReducers, applyMiddleware } from "redux";
import { configureStore } from '@reduxjs/toolkit'
// import thunk from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";
import {
    userListReducer,
    userUpdateReducer,
} from "./reducers/userReducers";

import { areaEditReducer } from "./reducers/areaRucers";
import langReducer from "./reducers/langReducers"
import menuReduces from './reducers/menuReduces';
import volunReduces from './reducers/volunteerReducers';
import projectReduces from './reducers/projectReducers';
/**
 * 以第一行为例，userListReducer计算返回的对象，为state中userList对应的value值
 */
// const reducer = combineReducers({
//     userList: userListReducer,
//     userUpdate: userUpdateReducer,
//     areaEdit: areaEditReducer,
// });

export default configureStore({
    reducer: {
        userList: userListReducer,
        userUpdate: userUpdateReducer,
        areaEdit: areaEditReducer,
        langList:langReducer,
        menuList:menuReduces,
        volunList:volunReduces,
        projectList:projectReduces
    }
  })

// const initialState = {

// };

// const middlewares = [thunk];

// const store = createStore(
//     reducer,
//     initialState,
//     composeWithDevTools(applyMiddleware(...middlewares))
// );

// export default store;
